import ym from "react-yandex-metrika";

import { EEventType } from "../store/analytics/types";

export const sendYandexEvent = (event: EEventType | string): void => {
  if (!process.env.REACT_APP_YM_CODE) return;
  ym('reachGoal', event);
};
